import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "donation-box-title" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, [
      _createElementVNode("img", {
        src: $props.img,
        alt: "new-img.png"
      }, null, 8 /* PROPS */, _hoisted_2)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($props.title), 1 /* TEXT */),
      ($props.tagline)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($props.tagline), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}